import React from "react";
import "../MembershipSection.css";

const MembershipCard = ({
  membership,
  getMembershipLabel,
  diffDateMessage,
}) => {
  const isExpired =
    new Date(membership.endDate).getTime() - new Date().getTime() < 0;

  return (
    <div className="membership-card">
      <div className="membersip-card-header">
        <h3>Üyeliğim</h3>
        <p className="membership-type">{getMembershipLabel(membership.name)}</p>
      </div>
      <div className="card-body">
        <p>
          <strong>Başlama Tarihi:</strong>{" "}
          {new Date(membership.startDate).toLocaleDateString("tr-TR")}
        </p>
        <p>
          <strong>Bitiş Tarihi:</strong>{" "}
          {new Date(membership.endDate).toLocaleDateString("tr-TR")}
        </p>
        <p className="remaining-time">
          <span
            className={`status-icon ${isExpired ? "expired" : "active"}`}
          ></span>
          <strong>Kalan Süre: </strong>
          &nbsp;
          <span className={isExpired ? "text-danger" : "text-success"}>
            {diffDateMessage(new Date(membership.endDate), new Date())}
          </span>
        </p>
      </div>
    </div>
  );
};

const UpgradeCard = ({ paymentLink }) => {
  return (
    <div className="upgrade-card">
      <div className="membersip-card-header">
        <h3>Üyeliğimi Yükselt</h3>
        <p className="membership-type">12 aylık standart üyelik paketi</p>
      </div>
      <div className="card-body">
        <p>Paketinizin süresi bir yıllık süreyi kapsar.</p>
        <h4 className="toplam-kdv">
          <small>12 ay için geçerli</small> ₺2.000 + KDV
        </h4>
        <a className="purchase-button fancy" href={paymentLink}>
          Satın Al <span className="cart-icon"></span>
        </a>
      </div>
    </div>
  );
};

const MembershipSection = ({
  membership,
  goldPayment,
  paymentLink,
  getMembershipLabel,
  diffDateMessage,
}) => {
  return (
    <div className="membership-section">
      <MembershipCard
        membership={membership}
        getMembershipLabel={getMembershipLabel}
        diffDateMessage={diffDateMessage}
      />
      {goldPayment && <UpgradeCard paymentLink={paymentLink} />}
    </div>
  );
};

export default MembershipSection;
